import {useQuery} from 'react-query';
import {useGet} from '../useHttpHooks.ts';
import {useAuthStateManager} from '../../hooks/useAuthStateManager.tsx';

interface SceneViewerToken {
    token: string;
    expiresAt: string;
}

const STALE_MS = 12 * 60 * 60 * 1000; // tokens last 24 hours

// A read-only pass for one project's scene frames (SceneReadTokens on the
// server), so they can load a private project's data without the viewer's
// session. Only asked for when signed in; without one, or if the viewer can't
// see the project, frames load anonymously and public projects still render.
const useSceneViewerToken = (projectId: string) => {
    const {isAuthenticated} = useAuthStateManager();
    const fetchToken = useGet<SceneViewerToken>(
        `/api/scene/${projectId}/viewer-token`
    );

    const {data, isLoading, isIdle} = useQuery(
        ['sceneViewerToken', projectId],
        fetchToken,
        {
            enabled: isAuthenticated,
            retry: false,
            staleTime: STALE_MS,
            cacheTime: STALE_MS,
            refetchOnWindowFocus: false
        }
    );

    return {
        token: isAuthenticated ? data?.token ?? null : null,
        ready: !isAuthenticated || (!isLoading && !isIdle)
    };
};

export default useSceneViewerToken;
